import { SystemCdKeyVerify, SystemCdKeyInsert, SystemCdKeyDelete, SystemCdKeyUpdate, SystemCdKeyGetById, SystemCdKeyGetList, SystemCdKeyGetPageList } from "@/api/systemcdkey/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 验证
    SystemCdKeyVerify(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemCdKeyVerify({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    SystemCdKeyInsert(context, payload) {
        return new Promise((resolve, reject) => {
            SystemCdKeyInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemCdKeyUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemCdKeyUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemCdKeyGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemCdKeyGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemCdKeyGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemCdKeyGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemCdKeyGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemCdKeyGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}